import React, { Component } from 'react';
import { Card, Header, Button, Image, Icon, Form, Feed, Divider, Menu, Grid } from 'semantic-ui-react'

export function Sectionheader(props) {
    return (
        <div>
            <Image src={require('../../images/printboda_logo.png')} />
            <Header as='h2' color='blue' textAlign='center' >
                {props.mainHeader}
            <Header.Subheader>
                    {props.subHeader}
        </Header.Subheader>
            </Header>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/newSite/NewSiteParts.js